import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./CreateGeneralReimbursement.css";
import axios from "axios";
import { UserConsumer } from "../../../../UserContext";
import GeneralReimbursementForm from "./GeneralReimbursementForm";
import { ReimbursementAPIs } from "../../MyReimbursementAPI's";
import { GeneralReimbursementAPIs } from "./GeneralReimbursementAPIS";
import { useHistory, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import FormStatus from "../../../../components/FormStatus";
import { AlertPopups } from "../../../../components/AlertPopups";

const CreateGeneralReimbursement = () => {
	let token = null;
	const history = useHistory();
	const { id } = useParams();
	let empDepartment = null;
	const [enterDetails, setEnterDetails] = useState(true);
	const { state } = useLocation();
	const reimbursementStatus = state ? state.status : null;

	const initialValues = {
		mealDate: null,
		mealType: 0,
		mealAmount: 0,
		mealDetails: null,
		travelDate: null,
		travelType: 0,
		travelAmount: 0,
		travelDetails: null,
		cashDate: null,
		cashAmount: 0,
		cashDetails: null,
		remarks: null,
		grandTotal: 0,
		employeeName: "",
	};
	const [generalReimbursement, setgeneralReimbursement] =
		useState(initialValues);
	const [mealDate, setMealDate] = useState(null);
	const [travelDate, setTravelDate] = useState(null);
	const [cashDate, setCashDate] = useState(null);
	const [mealTypes, setmealTypes] = useState([]);
	const [travelTypes, settraveTypes] = useState([{}]);
	const [empCode, setEmpCode] = useState();
	const [empName, setEmpName] = useState();

	const [formStatus, setFormStatus] = useState("Draft");
	const [travelDateCalendar, setTravelDateCalendar] = useState(false);
	const [mealDateCalendar, setMealDateCalendar] = useState(false);
	const [cashDateCalendar, setCashDateCalendar] = useState(false);
	const [specificRecord, setSpecificRecord] = useState(false);
	const [submissionStatus, setSubmissionStatus] = useState(1);
	const [recordAppliedDate, setRecordAppliedDate] = useState("");
	const mealTyper = [
		{ value: 0, label: "Official" },
		{ value: 1, label: "off Day Meals" },
		{ value: 2, label: "Late Sitting" },
		{ value: 3, label: "Team Lunch" },
	];
	const travelTyper = [
		{ value: 0, label: "Official" },
		{ value: 1, label: "Late Sitting" },
	];

	useEffect(() => {
		getMealTypes();
		getTravelTypes();
		getEmpInfo();
		if (id) {
			axios
				.get(
					`${ReimbursementAPIs.GetSingleGeneralReimbursement}/${id}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					setgeneralReimbursement({
						mealDate: data.mealDate,
						mealType: data.mealType,
						mealAmount: data.mealAmount,
						mealDetails: data.mealDetails,
						travelDate: data.travelDate,
						travelType: data.travelType,
						travelAmount: data.travelAmount,
						travelDetails: data.travelDetails,
						cashDate: data.cashDate,
						cashAmount: data.cashAmount,
						cashDetails: data.cashDetails,
						remarks: data.remarks,
						grandTotal: data.grandTotal,
						employeeName: data.employeeName,
					});
					setSpecificRecord(true);
					setFormStatus(data.status);
					setRecordAppliedDate(data.appliedDate);
					setEmpCode(data.employeeCode);
					setEmpName(data.employeeName);
					let mealType = mealTyper.find(
						(x) => x.value === data.mealType
					);
					let travelType = travelTyper.find(
						(x) => x.value === data.travelType
					);
					setgeneralReimbursement({
						...generalReimbursement,
						["mealType"]: mealType,
						["travelType"]: travelType,
						mealDate: data.mealDate,
						mealAmount: data.mealAmount,
						mealDetails: data.mealDetails,
						travelDate: data.travelDate,
						travelAmount: data.travelAmount,
						travelDetails: data.travelDetails,
						cashDate: data.cashDate,
						cashAmount: data.cashAmount,
						cashDetails: data.cashDetails,
						remarks: data.remarks,
						grandTotal: data.grandTotal,
						employeeName: data.employeeName,
					});
				});
		}
	}, []);

	const mealDatehandleChange = (e) => {
		debugger;
		setEnterDetails(false);
		if (id) {
			setgeneralReimbursement({
				...generalReimbursement,
				["mealDate"]: e,
			});
		} else {
			setgeneralReimbursement({
				...generalReimbursement,
				["mealDate"]: e,
			});

			setMealDate(e);
		}
	};

	const travelDatehandleChange = (e) => {
		setEnterDetails(false);
		if (id) {
			setgeneralReimbursement({
				...generalReimbursement,
				["travelDate"]: e,
			});
		} else {
			setgeneralReimbursement({
				...generalReimbursement,
				["travelDate"]: e,
			});
			setTravelDate(e);
		}
	};
	const cashDatehandleChange = (e) => {
		setEnterDetails(false);
		setgeneralReimbursement({ ...generalReimbursement, ["cashDate"]: e });
		setCashDate(e);
	};
	const handleChange = (e) => {
		setEnterDetails(false);
		setgeneralReimbursement({
			...generalReimbursement,
			[e.target.name]: e.target.value,
		});
	};
	const getEmpInfo = () => {
		axios
			.get(`${GeneralReimbursementAPIs.GetEmpInfo}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setEmpCode(data.empCode);
				setEmpName(data.employeeName);
			});
	};
	const mealTypeReactSelect = (e) => {
		setEnterDetails(false);
		setgeneralReimbursement({
			...generalReimbursement,
			["mealType"]: { value: e.value, label: e.label },
		});
	};

	const travelTypeReactSelect = (e) => {
		setEnterDetails(false);
		setgeneralReimbursement({
			...generalReimbursement,
			["travelType"]: { value: e.value, label: e.label },
		});
	};
	//API to get mealType
	const getMealTypes = () => {
		axios
			.get(`${GeneralReimbursementAPIs.GetMealType}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setmealTypes(res.data.mealTypes);
			});
	};
	const getTravelTypes = () => {
		axios
			.get(`${GeneralReimbursementAPIs.GetTravelType}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				settraveTypes(res.data.travelTypes);
			});
	};
	const { mealAmount, cashAmount, travelAmount } = generalReimbursement;
	const grandTotal =
		parseInt(mealAmount) + parseInt(travelAmount) + parseInt(cashAmount);

		const formatDateOnly = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`; // always local date
};

	const handleSubmit = () => {
		debugger;
		const body = {
			mealDate: formatDateOnly(generalReimbursement.mealDate),
			mealType: generalReimbursement.mealType.value,
			mealAmount: generalReimbursement.mealAmount,
			mealDetails: generalReimbursement.mealDetails,
			travelDate: formatDateOnly(generalReimbursement.travelDate),
			travelType: generalReimbursement.travelType.value,
			travelAmount: generalReimbursement.travelAmount,
			travelDetails: generalReimbursement.travelDetails,
			cashDate: formatDateOnly(generalReimbursement.cashDate),
			cashAmount: generalReimbursement.cashAmount,
			cashDetails: generalReimbursement.cashDetails,
			remarks: generalReimbursement.remarks,
		};
		if (enterDetails) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Select any Date",
			});
		} else if (
			generalReimbursement.mealAmount > 0 &&
			generalReimbursement.mealDate === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Meal Date",
			});
		} else if (
			generalReimbursement.mealDate != null &&
			generalReimbursement.mealAmount === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Meal Amount",
			});
		} else if (
			generalReimbursement.mealType === 0 &&
			generalReimbursement.mealDetails === null &&
			generalReimbursement.travelDetails === null &&
			generalReimbursement.cashDetails === null &&
			generalReimbursement.cashDate === null &&
			generalReimbursement.travelDate === null &&
			generalReimbursement.cashAmount === 0 &&
			generalReimbursement.travelAmount === 0 &&
			generalReimbursement.travelType === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Meal Details",
			});
		} else if (
			generalReimbursement.mealAmount > 0 &&
			generalReimbursement.mealDetails === null &&
			generalReimbursement.cashAmount === 0 &&
			generalReimbursement.travelAmount === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Meal Details",
			});
		} else if (
			generalReimbursement.mealDetails != null &&
			generalReimbursement.mealType === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Meal Type",
			});
		} else if (
			generalReimbursement.mealAmount === 0 &&
			generalReimbursement.mealType != 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Meal Amount",
			});
		} else if (
			generalReimbursement.mealDate != null &&
			generalReimbursement.mealDetails === null &&
			generalReimbursement.travelDetails === null &&
			generalReimbursement.cashDetails === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Meal Details",
			});
		} else if (
			generalReimbursement.travelAmount > 0 &&
			generalReimbursement.travelDate === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Travel Date",
			});
		} else if (
			generalReimbursement.travelDate != null &&
			generalReimbursement.travelAmount === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Travel Amount",
			});
		} else if (
			generalReimbursement.travelType === 0 &&
			generalReimbursement.travelDetails === null &&
			generalReimbursement.cashDetails === null &&
			generalReimbursement.cashDate === null &&
			generalReimbursement.travelDate === null &&
			generalReimbursement.cashAmount === 0 &&
			generalReimbursement.mealType === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Travel Details",
			});
		} else if (
			generalReimbursement.travelDetails != null &&
			generalReimbursement.travelType === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Travel Type",
			});
		} else if (
			generalReimbursement.travelAmount === 0 &&
			generalReimbursement.travelType != 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Travel Amount",
			});
		} else if (
			generalReimbursement.travelDate != null &&
			generalReimbursement.travelDetails === null &&
			generalReimbursement.cashDetails === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Travel Details",
			});
		} else if (
			generalReimbursement.cashAmount > 0 &&
			generalReimbursement.cashDate === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Cash Date",
			});
		} else if (
			generalReimbursement.cashDate != null &&
			generalReimbursement.cashAmount === 0
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Cash Amount",
			});
		} else if (
			generalReimbursement.cashDate != null &&
			generalReimbursement.cashDetails === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter Cash Details",
			});
		} else {
			AlertPopups.confirmBox
				.fire({
					text: "Are you sure you want to submit?",
				})
				.then((result) => {
					if (result.value) {
						axios
							.post(
								`${GeneralReimbursementAPIs.PostGeneralReimbursement}`,
								body,
								{
									headers: {
										Authorization: `Bearer ${token}`,
									},
								}
							)
							.then(({ data }) => {
								setgeneralReimbursement(data);
								AlertPopups.successAlert.fire({
									text: "Form Submitted",
								});
								//history.push("/MyReimbursement");
								history.push({
									pathname: "/MyReimbursement",
									state: {
										path: "generalReimbursement",
									},
								});
							})
							.catch((err) => {
								if (err.response) {
									AlertPopups.ErrorAlert.fire({
										text: `${err.response.data.message}`,
									});
								}
							});
					}
				});
		}
	};

	const handleReset = () => {
		setgeneralReimbursement({
			...generalReimbursement,
			cashDetails: "",
			remarks: "",
			mealDetails: "",
			travelDetails: "",
			mealDate: null,
			mealType: 0,
			mealAmount: 0,
			mealDetails: "",
			travelDate: null,
			travelType: 0,
			travelAmount: 0,
			travelDetails: "",
			cashDate: null,
			cashAmount: 0,
		});
		setMealDate(null);
		setTravelDate(null);
		setCashDate(null);
	};

	const startDateOpenCalendar = () => {
		if (travelDateCalendar) {
			setTravelDateCalendar(false);
		} else {
			setTravelDateCalendar(true);
		}
	};
	const mealDateOpenCalendar = () => {
		if (mealDateCalendar) {
			setMealDateCalendar(false);
		} else {
			setMealDateCalendar(true);
		}
	};
	const cashDateOpenCalendar = () => {
		if (cashDateCalendar) {
			setCashDateCalendar(false);
		} else {
			setCashDateCalendar(true);
		}
	};
	const goToPreviousPath = () => {
		history.push({
			pathname: "/MyReimbursement",
			state: {
				path: "generalReimbursement",
			},
		});
	};
	const updateRecord = (value) => {
		const body = {
			mealDate: generalReimbursement.mealDate,
			mealType: generalReimbursement.mealType.value,
			mealAmount: generalReimbursement.mealAmount,
			mealDetails: generalReimbursement.mealDetails,
			travelDate: generalReimbursement.travelDate,
			travelType: generalReimbursement.travelType.value,
			travelAmount: generalReimbursement.travelAmount,
			travelDetails: generalReimbursement.travelDetails,
			cashDate: generalReimbursement.cashDate,
			cashAmount: generalReimbursement.cashAmount,
			cashDetails: generalReimbursement.cashDetails,
			remarks: generalReimbursement.remarks,
			submissionStatus: value,
		};
		axios
			.put(
				`${GeneralReimbursementAPIs.UpdateGeneralReimbursementRecord}/${id}`,
				body,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				AlertPopups.successAlert.fire({
					text: "Record Updated Successfully",
				});
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	const changeGeneralReimbursementStatus = (value) => {
		setSubmissionStatus(value);
		updateRecord(value);
		let body = {
			submissionStatus: value,
		};
		axios
			.patch(
				`${GeneralReimbursementAPIs.ChangeReimbursementStatus}/${id}/ChangeStatus`,
				body,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				if (id) {
					axios
						.get(
							`${ReimbursementAPIs.GetSingleGeneralReimbursement}/${id}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then(({ data }) => {
							setgeneralReimbursement({
								mealDate: data.mealDate,
								mealType: data.mealType,
								mealAmount: data.mealAmount,
								mealDetails: data.mealDetails,
								travelDate: data.travelDate,
								travelType: data.travelType,
								travelAmount: data.travelAmount,
								travelDetails: data.travelDetails,
								cashDate: data.cashDate,
								cashAmount: data.cashAmount,
								cashDetails: data.cashDetails,
								remarks: data.remarks,
								grandTotal: data.grandTotal,
								employeeName: data.employeeName,
							});
							setSpecificRecord(true);
							setFormStatus(data.status);
							let mealType = mealTyper.find(
								(x) => x.value === data.mealType
							);
							let travelType = travelTyper.find(
								(x) => x.value === data.travelType
							);
							setgeneralReimbursement({
								...generalReimbursement,
								["mealType"]: mealType,
								["travelType"]: travelType,
							});
						});
				}
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDepartment = userDetails.department;
				return (
					<Container fluid>
						<FormStatus
							className="reimbursemnet-create-req-title"
							onClick={goToPreviousPath}
							formStatus={formStatus}
							navigateBack={true}
							title={
								formStatus != "Draft"
									? `Reimbursement Month : ${moment(
											recordAppliedDate
									  ).format("MMMM YYYY")}`
									: "Create New Request"
							}
						/>
						<Col lg={10} className="reimbursement-month my-4">
							Employee:
							<span className="emp-code">
								{" "}
								{empName} ({empCode})
							</span>{" "}
						</Col>
						<GeneralReimbursementForm
							mealDatehandleChange={mealDatehandleChange}
							mealDate={mealDate}
							travelDate={travelDate}
							cashDate={cashDate}
							travelDatehandleChange={travelDatehandleChange}
							cashDatehandleChange={cashDatehandleChange}
							mealTypes={mealTypes}
							travelTypes={travelTypes}
							handleSubmit={handleSubmit}
							handleChange={handleChange}
							generalReimbursement={generalReimbursement}
							setgeneralReimbursement={setgeneralReimbursement}
							mealTypeReactSelect={mealTypeReactSelect}
							handleReset={handleReset}
							grandTotal={grandTotal}
							reimbursementStatus={reimbursementStatus}
							initialValues={generalReimbursement}
							travelTypeReactSelect={travelTypeReactSelect}
							startDateOpenCalendar={startDateOpenCalendar}
							mealDateOpenCalendar={mealDateOpenCalendar}
							cashDateOpenCalendar={cashDateOpenCalendar}
							travelDateCalendar={travelDateCalendar}
							mealDateCalendar={mealDateCalendar}
							cashDateCalendar={cashDateCalendar}
							specificRecord={specificRecord}
							updateRecord={updateRecord}
							recordID={id}
							empDepartment={empDepartment}
							changeGeneralReimbursementStatus={
								changeGeneralReimbursementStatus
							}
							formStatus={formStatus}
						/>
					</Container>
				);
			}}
		</UserConsumer>
	);
};

export default CreateGeneralReimbursement;
